import React from 'react';
import {Button} from "@mui/material";
import {FormattedMessage} from "react-intl";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

type ExportButtonProps = {
    onClick: () => void;
    color?: string;
};

const ExportButton: React.FC<ExportButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "secondary"}
            startIcon={<FileDownloadIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_EXPORT'}/>
        </Button>
    );
};
export default ExportButton;
